import React from 'react';

import { JiraServiceManagementIcon } from '@atlaskit/logo/jira-service-management-icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <JiraServiceManagementIcon size="xsmall" label="" />;

export const useJiraServiceManagement = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.JIRA_SERVICE_MANAGEMENT,
		analyticsName: Products.JIRA_SERVICE_MANAGEMENT,
		...options,
	});
